module.exports = __webpack_public_path__ + "img/alejandro_chani.5614123e.png";